/**
 * Live / Test / All for the whole portal. Disabled on pages that aren't
 * split by environment, so it never looks like it filtered something it
 * didn't. Test turns amber: a list of test money must not pass for live.
 */
import { useLocation, useSearchParams } from "react-router-dom";
import { SelectNative } from "@/components/ui/select-native";
import type { TenantEnvironment } from "@/lib/api";
import { useEnvironment } from "@/lib/environment-context";
import { cn } from "@/lib/utils";

const SCOPED_PATHS: ReadonlySet<string> = new Set([
  "/",
  "/payment-intents",
  "/inbound-payments",
  "/balance-queries",
  "/callback-inbox",
  "/webhook-outbox",
  "/tenants",
]);

export function EnvironmentSwitch() {
  const { environment, setEnvironment } = useEnvironment();
  const { pathname } = useLocation();
  const [params, setParams] = useSearchParams();
  const scoped = SCOPED_PATHS.has(pathname);

  function select(value: string) {
    setEnvironment(value === "live" || value === "test" ? value : undefined);
    if (params.has("page")) {
      const nextParams = new URLSearchParams(params);
      nextParams.delete("page");
      setParams(nextParams, { replace: true });
    }
  }

  const selected: TenantEnvironment | "all" = environment ?? "all";
  return (
    <SelectNative
      aria-label="Environment"
      title={scoped ? undefined : "This page isn't split by environment"}
      disabled={!scoped}
      value={selected}
      onChange={(e) => select(e.target.value)}
      className={cn(
        "h-9 w-20 shrink-0 text-xs font-medium sm:w-24",
        selected === "test" &&
          "border-warning bg-warning text-white [&+svg]:text-white [&>option]:bg-background [&>option]:text-foreground",
      )}
    >
      <option value="live">Live</option>
      <option value="test">Test</option>
      <option value="all">All</option>
    </SelectNative>
  );
}
